import { CustomerStatus } from 'types/customers'

export const StatusMapping = {
  [CustomerStatus.VERIFIED]: 'success',
  [CustomerStatus.PENDING]: 'warning',
  [CustomerStatus.REJECTED]: 'error',
} as const

export const StatusLabelMapping = {
  [CustomerStatus.VERIFIED]: 'Success',
  [CustomerStatus.PENDING]: 'Under review',
  [CustomerStatus.REJECTED]: 'Not supported',
} as const

export const NESTED_CUSTOMERS_ERROR_MAPPING: Record<string, string> = {
  'company.address.addressLine1': 'addressLine1',
  'company.address.city': 'city',
  'company.address.countryCode': 'countryCode',
  'company.address.postalCode': 'postalCode',
  'company.description': 'businessDescription',
  'company.industryReference': 'industry',
  'company.monthlyExpectedVolumesReference': 'businessMonthlyVolume',
  'company.name': 'businessName',
  'company.registrationNumber': 'registrationNumber',
  'company.representive.address.countryCode': 'monthlyExpectedVolumes',
  'company.representative.dateOfBirth': 'dateOfBirth',
  'company.representative.firstName': 'firstName',
  'company.representative.lastName': 'lastName',
  'company.taxResidenceCountryCode': 'businessTaxResidency',
  'company.address.addressLine2': 'addressLine2',
  'company.address.stateCode': 'stateCode',

  'individual.firstName': 'firstName',
  'individual.lastName': 'lastName',
  'individual.dateOfBirth': 'dateOfBirth',
  'individual.person.details.documentNumber': 'personalIdNumber',
  'individual.person.details.birthCountryCode': 'nationality',
  'individual.person.details.nationality': 'nationality',
  'individual.person.details.residenceCountryCode': 'countryCode',
  'individual.person.address.addressLine1': 'addressLine1',
  'individual.person.address.addressLine2': 'addressLine2',
  'individual.person.address.city': 'city',
  'individual.person.address.postalCode': 'postalCode',
  'individual.person.address.countryCode': 'countryCode',
  'individual.person.address.stateCode': 'stateCode',
  'individual.description': 'individualCustomerDescription',
}
